import React from 'react';
import { Accordion, Box } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useFormContext } from 'react-hook-form';

import { ICreateBenefitGroupForm } from '@epi-models/pages/BenefitGroups';

import { MyChoiceDisclaimerContent } from './MyChoiceDisclaimerContent';
import { MyChoiceDisclaimerTitle } from './MyChoiceDisclaimerTitle';
import { BenefitType } from '@epi-constants/benefitTypes';

const MyChoiceDisclaimer = () => {
  const { gray25 } = useTheme();
  const { watch } = useFormContext<ICreateBenefitGroupForm>();
  const benefits = watch(`benefitSettings`);

  const selectedMyChoiceBenefit = Object.entries(benefits).filter(
    ([benefitType, value]) => !!value && benefitType !== BenefitType.Lunch
  );

  if (selectedMyChoiceBenefit.length === 0) {
    return null;
  }

  return (
    <Box borderBottom={`1px solid ${gray25}`}>
      <Accordion
        summaryChild={<MyChoiceDisclaimerTitle />}
        detailsChild={<MyChoiceDisclaimerContent />}
      />
    </Box>
  );
};

export { MyChoiceDisclaimer };
